// export const RPC_URL = 'http://139.162.27.161:26657';
export const RPC_URL = 'https://explorer.honeywood.io/node'; // ! на это потом переключить при заливке на прод
export const API_URL_EXPLORER = 'https://explorer.honeywood.io/api';
export const RPC_URL_DEV = 'https://dev.honeywood.io/node'; // ! для теста и проверки
// export const RPC_URL = 'https://dev.honeywood.io/node/blockchain'; // ! Рома указал этот адрес для getLatestBlocks
export const MILLION_MULTIPLIER = 1000000.0;
export const GAS_WANTED = 2000000;
export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const TOOLTIP_DELAY = 5000;
export default {
  RPC_URL,
  RPC_URL_DEV,
};
